import { Component, Inject, Input, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeedbackService } from '../../../service/feedback.service';
import {
  AppTab,
  DialogData,
  BotEvaluationResponse
} from '../../../utility/feedback';


@Component({
    selector: 'app-evaluate-feedback',
    templateUrl: './evaluate-feedback.component.html',
    styleUrl: './evaluate-feedback.component.scss',
    standalone: false
})
export class EvaluateFeedbackComponent {
  @Input() feedbackId: number;
  @Input() selectedTabIndex?: number;
  @Input() targetTabLabel?: string;
  tabData: BotEvaluationResponse | null = null;
  hasEvaluations: boolean = false;
  issuesLabelMetadata: any[] = [];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private feedbackService: FeedbackService,
    @Optional() private dialogRef: MatDialogRef<EvaluateFeedbackComponent>
  ) {
    if (data && data.feedbackId) {
      this.feedbackId = data.feedbackId;
    }
  }
  ngOnInit() {
    this.getTabData(this.feedbackId);
    //this.labelDescription();
  }

  tabs: AppTab[] = [];

  newTabName = '';
  selectedIndex = 0;

  uid(prefix = '') {
    return prefix + Math.random().toString(36).slice(2, 9);
  }

  getTabData(feedbackId: number): void {
    this.feedbackService.botEvaluationTab(feedbackId).subscribe((data: BotEvaluationResponse) => {
      this.tabData = data;

      // Support different response shapes: evaluations may be at root or nested
      const evaluations = (data as any).evaluations || (data as any).bot_eval_with_feedback?.evaluations || [];

      if (evaluations && Array.isArray(evaluations) && evaluations.length > 0) {
        this.hasEvaluations = true;
        const evaluation = evaluations[0];
        // Build tab descriptions from each metric's header/description
        this.tabDescriptions = {};
        Object.keys(evaluation).forEach(key => {
          const wrapper = evaluation[key];
          if (wrapper && typeof wrapper === 'object' && wrapper.header) {
            this.tabDescriptions[wrapper.header] = {
              id: 0,
              description: wrapper.description || ''
            };
          }
        });
        this.buildTabsFromEvaluations(evaluation);
      } else {
        this.hasEvaluations = false;
        this.tabs = [];
      }
    });
  }

  buildTabsFromEvaluations(evaluation: any): void {
    this.tabs = [];

    Object.keys(evaluation).forEach(key => {
      const wrapper = evaluation[key];
      if (!wrapper || typeof wrapper !== 'object' || !wrapper.header) return;

      const metric = wrapper.metric;
      const header = wrapper.header;
      const items: string[] = [];

      if (metric === null || metric === undefined) {
        items.push('No data available');
      } else if (typeof metric === 'string') {
        items.push(metric);
      } else if (typeof metric === 'object' && !Array.isArray(metric)) {
        if ('score' in metric) {
          items.push(`Score: ${this.formatScore(metric.score)}`);
          if (metric.reason) {
            items.push(`Reason: ${metric.reason}`);
          }
        }
        if ('verdict' in metric) {
          items.push(`Verdict: ${metric.verdict || 'N/A'}`);
          if (metric.clarification_request) {
            items.push(`Clarification: ${metric.clarification_request}`);
          }
          if (metric.reason && !('score' in metric)) {
            items.push(`Reason: ${metric.reason}`);
          }
        }
        if (!('score' in metric) && !('verdict' in metric)) {
          const friendlyLabels = wrapper.business_friendly_labels || {};
          const metricKeys = Object.keys(metric);
          if (metricKeys.length > 0) {
            metricKeys.forEach(mk => {
              if (metric[mk]) {
                const friendly = friendlyLabels[mk] || mk;
                items.push(`${friendly} (${mk}): ${metric[mk]}`);
              }
            });
          } else {
            items.push('No data available');
          }
        }
      } else if (Array.isArray(metric)) {
        if (metric.length > 0) {
          metric.forEach(item => items.push(String(item)));
        } else {
          items.push('No data available');
        }
      }

      this.tabs.push({
        id: this.uid('tab-'),
        label: header,
        title: header,
        items: items
      });
    });

    if (this.selectedTabIndex !== undefined && this.selectedTabIndex >= 0 && this.selectedTabIndex < this.tabs.length) {
      this.selectedIndex = this.selectedTabIndex;
    }

    if (this.targetTabLabel) {
      const targetIndex = this.tabs.findIndex(tab => tab.label === this.targetTabLabel);
      if (targetIndex >= 0) {
        this.selectedIndex = targetIndex;
      }
    }
  }

  formatScore(score: number | string | undefined): string {
    if (score === undefined || score === null || score === '') {
      return 'N/A';
    }
    const numScore = typeof score === 'string' ? parseFloat(score) : score;
    if (isNaN(numScore)) {
      return 'N/A';
    }
    return `${numScore.toFixed(2)}/1`;
  }
  // labelDescription() {
  //   this.feedbackService.getEvalutionDescription().subscribe((response: any[]) => {
  //     // Map tabDescriptions using header (tab label) as key, storing the full object
  //     this.tabDescriptions = {};
  //     response.forEach(item => {
  //       if (item.header) {
  //         this.tabDescriptions[item.header] = {
  //           id: item.id,
  //           description: item.description
  //         };
  //       }
  //     });
  //     console.log('TabDescriptions:', this.tabDescriptions);
  //   });
  // }

  tabDescriptions: { [label: string]: { id: number; description: string } } = {};
  closeDialog(): void {
    this.dialogRef.close();
  }
}
